import standardChess from "./standardChess";
import fischerRandomChess from "./fischerRandomChess";

const gameTypes = {
  standardChess,
  fischerRandomChess
};

export default gameTypes;